var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6993_51917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59781 19.9615C10.2298 19.9615 13.1741 17.0735 13.1741 13.511C13.1741 9.94849 10.2298 7.06055 6.59781 7.06055C2.96581 7.06055 0.0214844 9.94849 0.0214844 13.511C0.0214844 17.0735 2.96581 19.9615 6.59781 19.9615Z",
    fill: "#04E061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0061 19.1471C20.2008 19.1471 21.9799 17.402 21.9799 15.2493C21.9799 13.0966 20.2008 11.3516 18.0061 11.3516C15.8114 11.3516 14.0322 13.0966 14.0322 15.2493C14.0322 17.402 15.8114 19.1471 18.0061 19.1471Z",
    fill: "#FF4053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85555 6.21955C9.2137 6.21955 10.3147 5.13965 10.3147 3.80753C10.3147 2.47541 9.2137 1.39551 7.85555 1.39551C6.49745 1.39551 5.39648 2.47541 5.39648 3.80753C5.39648 5.13965 6.49745 6.21955 7.85555 6.21955Z",
    fill: "#965EEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.463 10.5104C19.416 10.5104 21.8098 8.16239 21.8098 5.26597C21.8098 2.36951 19.416 0.0214844 16.463 0.0214844C13.51 0.0214844 11.1162 2.36951 11.1162 5.26597C11.1162 8.16239 13.51 10.5104 16.463 10.5104Z",
    fill: "#00AAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6993_51917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/Avito.b6ea83519665b3cfd797025c446a94f4.svg";
export { ForwardRef as ReactComponent };